import React from "react";
import bg from "../../assets/videos/reels.mp4";
import "./styles.css";
import { Link } from "react-router-dom";
import vector from "../../assets/videos/MIH Logo Icon (black).png";

export const LoveStories = () => {
  return (
    <div className="container homecontainer">
      <div className="vectorContainer" data-aos="fade-up">
        <img src={vector} className="vectorImage" alt="Vector Logo" />

        <div className="space-y-4" style={{ marginTop: "20px" }}>
          {/* <h3 className="text-2xl font-semibold tracking-widest" >
            RAW • REFINED • REVITING
          </h3> */}
          <p className="leading-relaxed max-w-2xl">
            Blending luxury with a focus on genuine emotion, we bring an artful
            eye to every celebration. Our passion is to capture your wedding day
            with an authenticity that resonates deeply, creating timeless
            keepsakes as beautiful as the love they embody.
          </p>
        </div>
      </div>

      <div className="container staticAboutContainer mt-5">
        <div className="filmContainer second oo">
          <div
            className="vidContainer"
            data-aos="fade-up"
            style={{
              pointerEvents: "none", // Prevent interaction with video
              position: "relative", // Required for proper positioning
            }}
          >
            <video
              className="video21"
              src={bg}
              autoPlay
              loop
              muted
              playsInline
              controlsList="nodownload nofullscreen noremoteplayback"
              disablePictureInPicture
              style={{
                pointerEvents: "none", // Extra protection against interaction
                userSelect: "none", // Prevent text selection
                WebkitTouchCallout: "none", // Prevent iOS context menu
              }}
            ></video>
          </div>
          <div
            className="inners"
            data-aos="fade-up"
            style={{
              backgroundColor: "#CEC4C0",
              padding: "15px",
              borderRadius: "20px",
            }}
          >
            <div className="loveContainer">
              <h3 className="text">CAPTURING THE ESSENCE OF YOUR</h3>
              <h2 className="title title1">Love stories</h2>
              <p className="description">
                Your wedding day isn't just an event; it's an exploration of
                your deepest emotions and the discovery of newfound love. Let's
                embark together beyond the tears of joy and the laughter of your
                loved ones, preserving the essence of your one-of-a-kind love
                story.
              </p>
              <Link to="/gallery">
                <button
                  className="watchFilmsButton"
                  style={{ backgroundColor: "#CEC4C0" }}
                >
                  Watch Films
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
